module.exports = "./img/e52a425554559d0d2677befa1c6a5da5.jpg";